import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

// Gate for the validation screens (Admin + Validateur). A BUILD account has no business here — it is
// sent to its own console rather than shown an empty queue that would 403 on every call (user ask
// 2026-08-07). Until now these routes had no role guard at all: only the API refused, so a wrong role
// saw the shell of a page it can't use.
export function InternalRoute() {
  const { isInternal } = useAuth();
  if (!isInternal) {
    return <Navigate to="/dmp-console" replace />;
  }
  return <Outlet />;
}
